var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalImagery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.78px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.48,
    y1: 49.52,
    x2: 107.48,
    y2: 143.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.4,83.36s8.48-12,13.68-13.68c2.16-.72,32.4,0,32.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.4,103.84s8.48-12,13.68-13.68c2.16-.72,32.4,0,32.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.4,124.32s8.48-11.95,13.68-13.68c2.16-.72,32.4,0,32.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.56,83.36s-8.48-12-13.68-13.68c-2.16-.72-32.4,0-32.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.56,103.84s-8.48-12-13.68-13.68c-2.16-.72-32.4,0-32.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.56,124.32s-8.48-11.95-13.68-13.68c-2.16-.72-32.4,0-32.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.84,143.84h53.28v14.4s-9.36,13-26.64,13A35.15,35.15,0,0,1,80.84,159Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 67.16,
    y1: 16.28,
    x2: 67.16,
    y2: 41.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 147.8,
    y1: 16.28,
    x2: 147.8,
    y2: 41.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.86,
    y: 29.66,
    width: 134.3,
    height: 160.98
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalImagery);
export default __webpack_public_path__ + "static/media/MEDICAL_IMAGERY.f039a192268bd65ef66262acac98c122.svg";
export { ForwardRef as ReactComponent };